import React, { useEffect, useState } from 'react';
import { PrimaryButton } from './PrimaryButton';
import { CHECKOUT_URL } from '../../utils/checkout';
import { trackInitiateCheckout } from '../../utils/metaPixel';
export function StickyCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        setVisible(window.scrollY > 640);
        ticking = false;
      });
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return (
    // No aria-hidden here: this bar holds a focusable link, and hiding a
    // container that still contains a focusable descendant traps keyboard/AT
    // users on an unreachable control. Visibility is instead handled purely
    // through the transform (off-screen) plus pointer-events, and the link's
    // own tabIndex is removed while hidden so Tab skips right over it.
    <div className={`fixed inset-x-0 bottom-0 z-40 border-t border-gris-claro bg-white/95 backdrop-blur-sm transition-transform duration-300 lg:hidden ${visible ? 'translate-y-0' : 'pointer-events-none translate-y-full'}`} data-id="element-290" data-mp="o2xqnf8fzj4u">
      <div className="flex items-center justify-between gap-3 px-4 py-3" data-id="element-291" data-mp="121dv0ziu0xjt">
        <div data-id="element-292" data-mp="16zyxz6pgxvby">
          <p className="font-heading text-sm font-bold text-marino" data-id="element-293" data-mp="1708oqwic86ip">13,99€</p>
          <p className="text-[11px] text-gris-muted" data-id="element-294" data-mp="1b0snu5mh1k7h">Acceso inmediato</p>
        </div>
        <PrimaryButton size="md" href={CHECKOUT_URL} onClick={trackInitiateCheckout} tabIndex={visible ? undefined : -1} data-id="element-295" data-mp="1frr3d2zmye9o">
          Quiero mi Manual
        </PrimaryButton>
      </div>
    </div>
  );
}